import * as React from 'react';

import { STANDARDS_REPORT_IMG_SRC, } from './shared'

import { PREMIUM_STATE_LOCKED, PREMIUM_STATE_NONE, SKILLS_REPORT_IMG_SRC, } from '../shared/shared'
import { LARGE_ICON_BASE_SRC, } from '../../../../Shared/index'
import { requestPost, } from '../../../../../modules/request'

const productBezelImg = <img alt="" className="product-bezel" src={`${STANDARDS_REPORT_IMG_SRC}/standards-report-product-bezel@2x.png`} />
const studentAccountsImg = <img alt="" src={`${LARGE_ICON_BASE_SRC}/student-accounts.svg`} />
const assignedActivities = <img alt="" src={`${LARGE_ICON_BASE_SRC}/assigned-activities.svg`} />
const standardsImg = <img alt="" src={`${LARGE_ICON_BASE_SRC}/standards.svg`} />
const shannonHeadshotImg = <img alt="" src={`${SKILLS_REPORT_IMG_SRC}/shannon_headshot.svg`} />

interface LockedPageProps {
  premiumState: typeof PREMIUM_STATE_LOCKED | typeof PREMIUM_STATE_NONE;
}

const LockedPage = ({ premiumState, }: LockedPageProps) => {
  const beginTrial = () => {
    requestPost('/subscriptions', { subscription: { account_type: 'Teacher Trial', }, }, () => {
      window.location.reload()
    })
  }
  
  return (
    <div className="standards-report-locked-page container">
      <header>
        <span className="new-tag">NEW</span>
        <h1>Standards Report</h1>
        <p className="sub-header">See the full story of standards growth with complete learning history and actionable groups. Included with Quill Premium.</p>
      </header>
      <div className="buttons-wrapper">
        {premiumState !== PREMIUM_STATE_LOCKED && <button className="quill-button contained gold large focus-on-light" onClick={beginTrial} type="button">Try Premium free for 30 days</button>}
        <a className="quill-button contained gold large focus-on-light" href="/premium" rel="noopener noreferrer" target="_blank">Learn more about Premium</a>
      </div>
      {productBezelImg}
      <h2>Why Teachers Love This Report</h2>
      <section className="reasons">
        <div className="reason">
          {standardsImg}
          <h3>Standards-Aligned History</h3>
          <p>Get an accurate baseline of student ability against your state standards. Powered by a student’s full Quill history across teachers and classes, it gives a complete picture of their understanding of every standard.</p>
        </div>
        <div className="reason">
          {assignedActivities}
          <h3>Growth-Focused Scores</h3>
          <p>Based on Quill’s proprietary algorithm, the Momentum Score celebrates the learning process. It values recent improvement and consistent effort, ensuring early mistakes never define a student’s potential.</p>
        </div>
        <div className="reason">
          {studentAccountsImg}
          <h3>Actionable Smart Groups</h3>
          <p>Set your own goal, and Smart Groups adapt. Students are automatically organized into categories like Needs Support or Meeting Goal, so you know exactly who needs support and where to focus instruction.</p>
        </div>
      </section>
      <section className="testimonial">
        {shannonHeadshotImg}
        <p className="quote">“The Standards Report brings powerful clarity to standards-based instruction. By using each student’s full activity history, it gives teachers a reliable view of progress on every standard and a clear roadmap for targeted reteaching and next steps.”</p>
        <p className="attribution">Shannon Browne, Professional Learning Manager</p>
      </section>
    </div>
  )
}

export default LockedPage
